var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"icon-left":"magnify","tag":"router-link","to":("/" + _vm.model + "/" + _vm.id),"title":"Voir"}})}
var staticRenderFns = []

export { render, staticRenderFns }